import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "flex h-full flex-col gap-5 overflow-y-auto p-4 pt-20 xl:p-8 xl:pt-8" };
const _hoisted_2 = { class: "flex flex-col gap-4 md:flex-row md:items-center md:justify-between" };
const _hoisted_3 = { class: "text-sm font-medium text-eorange-600" };
const _hoisted_4 = { class: "text-2xl font-bold text-eblack-900" };
const _hoisted_5 = { class: "text-sm text-eblack-500" };
const _hoisted_6 = { class: "grid gap-4 sm:grid-cols-2 lg:grid-cols-3" };
const _hoisted_7 = { class: "mb-4 flex items-start justify-between gap-3" };
const _hoisted_8 = { class: "text-lg font-semibold text-eblack-900" };
const _hoisted_9 = { class: "text-sm capitalize text-eblack-500" };
const _hoisted_10 = { class: "flex flex-wrap gap-2" };
const _hoisted_11 = ["onClick"];
const _hoisted_12 = ["onClick"];
const _hoisted_13 = ["onClick"];
const _hoisted_14 = ["onClick"];
const _hoisted_15 = {
    key: 0,
    class: "rounded-lg border bg-white p-8 text-center text-eblack-600"
};
const _hoisted_16 = {
    key: 1,
    class: "rounded-lg border bg-white p-8 text-center text-eblack-600"
};
import { i18n } from "@/i18n";
import { computed, onMounted } from "vue";
import { useRouter } from "vue-router";
import { IconPlus } from "@tabler/icons-vue";
import { useToast } from "vue-toastification";
import { useOverlay } from "@/services/overlay-service";
import { createModalConfig } from "@/utils/overlay-utils";
import { useAuthStore } from "@/domains/auth";
import { OrganizationFormSidebar, useOrganizationStore, useOrganizationContextSwitch, useOrganizations, } from "@/domains/organization";
export default /*@__PURE__*/ _defineComponent({
    __name: 'OrganizationsIndex',
    setup(__props) {
        const router = useRouter();
        const toast = useToast();
        const overlayService = useOverlay();
        const authStore = useAuthStore();
        const organizationStore = useOrganizationStore();
        const contextSwitch = useOrganizationContextSwitch();
        const { organizations, isLoading, load } = useOrganizations({
            autoLoad: false,
            onError: () => toast.error(i18n.global.t("organization.auto.no_se_pudieron_cargar_las_organizaciones")),
        });
        const activeMembershipByOrg = computed(() => new Map(authStore.activeMemberships.map((membership) => [membership.org_id, membership])));
        function openCreate() {
            overlayService.open(createModalConfig({
                component: OrganizationFormSidebar,
                size: "xl",
                closeOnBackdrop: false,
                events: {
                    saved: async () => {
                        await load(true);
                        await authStore.fetchUserProfile();
                        toast.success(i18n.global.t("organization.auto.organizacion_creada"));
                    },
                },
            }));
        }
        function enterOrg(orgId) {
            const membership = activeMembershipByOrg.value.get(orgId);
            if (membership) {
                contextSwitch.switchToMembershipOrg(membership);
            }
            else if (authStore.isSuperAdmin) {
                const organization = organizations.value.find((item) => item.id === orgId);
                if (organization) {
                    contextSwitch.switchToSuperAdminOrg(organization);
                }
                else {
                    return;
                }
            }
            router.push("/admin");
        }
        function statusLabel(organization) {
            if (organization.deleted_at)
                return "Eliminada";
            return organization.is_active ? "Activa" : "Inactiva";
        }
        function statusClass(organization) {
            if (organization.deleted_at)
                return "bg-red-100 text-red-700";
            return organization.is_active
                ? "bg-egreen-100 text-egreen-700"
                : "bg-eblack-100 text-eblack-600";
        }
        async function deactivateOrg(organization) {
            await organizationStore.deactivateOrganization(organization.id, {});
            await load(true);
            await authStore.fetchUserProfile();
            toast.success(i18n.global.t("organization.auto.organizacion_desactivada"));
        }
        async function reactivateOrg(organization) {
            await organizationStore.reactivateOrganization(organization.id, {});
            await load(true);
            await authStore.fetchUserProfile();
            toast.success(i18n.global.t("organization.auto.organizacion_reactivada"));
        }
        async function softDeleteOrg(organization) {
            const confirmation = window.prompt(`Escriba "${organization.display_name}" para confirmar la eliminación.`);
            if (confirmation !== organization.display_name) {
                toast.error(i18n.global.t("organization.auto.confirmacion_invalida"));
                return;
            }
            await organizationStore.softDeleteOrganization(organization.id, {
                confirmation,
            });
            await load(true);
            await authStore.fetchUserProfile();
            toast.success(i18n.global.t("organization.auto.organizacion_eliminada"));
        }
        onMounted(() => load(true));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t("organization.auto.consola_global")), 1),
                        _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.$t("organization.auto.organizaciones")), 1),
                        _createElementVNode("p", _hoisted_5, _toDisplayString(_ctx.$t("organization.auto.cree_y_administre_organizaciones_concierge_y_pro")), 1)
                    ]),
                    _createElementVNode("button", {
                        type: "button",
                        class: "inline-flex items-center justify-center gap-2 rounded-lg bg-egreen-500 px-4 py-2 text-sm font-medium text-white",
                        onClick: openCreate
                    }, [
                        _createVNode(_unref(IconPlus), { class: "h-4 w-4" }),
                        _createTextVNode(_toDisplayString(_ctx.$t("organization.auto.nueva_organizacion")), 1)
                    ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(organizations), (organization) => {
                        return (_openBlock(), _createElementBlock("article", {
                            key: organization.id,
                            class: "rounded-lg border border-ewhite-200 bg-white p-5 shadow-sm"
                        }, [
                            _createElementVNode("div", _hoisted_7, [
                                _createElementVNode("div", null, [
                                    _createElementVNode("h2", _hoisted_8, _toDisplayString(organization.display_name), 1),
                                    _createElementVNode("p", _hoisted_9, _toDisplayString(organization.org_type), 1)
                                ]),
                                _createElementVNode("span", {
                                    class: _normalizeClass(["rounded-full px-2 py-1 text-xs", statusClass(organization)])
                                }, _toDisplayString(statusLabel(organization)), 3)
                            ]),
                            _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "rounded-lg border border-ewhite-300 px-3 py-1.5 text-sm text-eblack-700",
                                    onClick: ($event) => (enterOrg(organization.id))
                                }, _toDisplayString(organization.is_active && !organization.deleted_at ? 'Entrar al contexto' : 'Ver archivo'), 9, _hoisted_11),
                                (organization.is_active && !organization.deleted_at)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        type: "button",
                                        class: "rounded-lg border border-yellow-300 px-3 py-1.5 text-sm text-yellow-700",
                                        onClick: ($event) => (deactivateOrg(organization))
                                    }, _toDisplayString(_ctx.$t("organization.auto.desactivar")), 9, _hoisted_12))
                                    : _createCommentVNode("", true),
                                (!organization.is_active && !organization.deleted_at)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 1,
                                        type: "button",
                                        class: "rounded-lg border border-egreen-300 px-3 py-1.5 text-sm text-egreen-700",
                                        onClick: ($event) => (reactivateOrg(organization))
                                    }, _toDisplayString(_ctx.$t("organization.auto.reactivar")), 9, _hoisted_13))
                                    : _createCommentVNode("", true),
                                (!organization.deleted_at)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 2,
                                        type: "button",
                                        class: "rounded-lg border border-red-300 px-3 py-1.5 text-sm text-red-700",
                                        onClick: ($event) => (softDeleteOrg(organization))
                                    }, _toDisplayString(_ctx.$t("organization.auto.eliminar")), 9, _hoisted_14))
                                    : _createCommentVNode("", true)
                            ])
                        ]));
                    }), 128))
                ]),
                (_unref(isLoading))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_15, _toDisplayString(_ctx.$t("organization.auto.cargando_organizaciones")), 1))
                    : _createCommentVNode("", true),
                (!_unref(isLoading) && _unref(organizations).length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, _toDisplayString(_ctx.$t("organization.auto.no_hay_organizaciones_creadas")), 1))
                    : _createCommentVNode("", true)
            ]));
        };
    }
});
